import { Form, message, Select, Input, DatePicker, Spin } from "antd";
import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Order from "../../../api/orderApi";
import {
  getStoragePersist,
  KEY_RECAPTCHA,
  RULES_ANTD,
  sortPrioritize,
} from "../../../constants";
import moment from "moment";
import { LoadingConfig } from "./../../../components/index";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { UserInfo } from "../../../appRedux/action/OrderAction";
const RegisterUserForm = () => {
  const dispatch = useDispatch();
  const { idUser } = useParams();
  const [loading, setLoading] = useState();
  const [form] = Form.useForm();
  const [captcha, setCaptcha] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);

  console.log("wards", wards);
  const [dataUser, setDataUser] = useState({
    name: idUser ? JSON.parse(localStorage.getItem("AUTH_INFO")).name : "",

    address: idUser
      ? JSON.parse(localStorage.getItem("AUTH_INFO")).address
      : "",
    birth_day: idUser
      ? JSON.parse(localStorage.getItem("AUTH_INFO")).birth_day
      : "",
    cccd: idUser ? JSON.parse(localStorage.getItem("AUTH_INFO")).cccd : "",
    code_inject: idUser
      ? JSON.parse(localStorage.getItem("AUTH_INFO")).code_inject
      : "",

    email: idUser ? JSON.parse(localStorage.getItem("AUTH_INFO")).email : "",
    gender: idUser ? JSON.parse(localStorage.getItem("AUTH_INFO")).gender : "",
    id: idUser ? JSON.parse(localStorage.getItem("AUTH_INFO")).id : "",

    phone_number: idUser
      ? JSON.parse(localStorage.getItem("AUTH_INFO")).phone_number
      : "",
    district_id: idUser
      ? JSON.parse(localStorage.getItem("AUTH_INFO")).district_id
      : "",
    province_id: idUser
      ? JSON.parse(localStorage.getItem("AUTH_INFO")).province_id
      : "",
    ward_id: idUser
      ? JSON.parse(localStorage.getItem("AUTH_INFO")).ward_id
      : "",
  });
  const handleChangeCaptcha = () => {
    setCaptcha(!captcha);
  };
  // console.log(getStoragePersist());
  // console.log(idUser);

  useEffect(() => {
    getList();
    return reset();
  }, []);
  const reset = () => {
    form.resetFields([]);
  };
  const getList = async () => {
    setLoading(true);
    // const temp = JSON.parse(localStorage.getItem("AUTH_INFO"));
    // console.log(temp);
    // if (temp !== null) setDataUser(temp);
    if (idUser) {
      await getProvinces();
      await getDistricts(dataUser?.province_id);
      await getWards(dataUser?.district_id);
    } else {
      Promise.all([getProvinces()]);
    }
    setLoading(false);
  };
  const getProvinces = async () => {
    const result = await Order.getProvinces();
    setProvinces(result.data);
  };
  const getDistricts = async (id) => {
    if (id) {
      const value = {
        province_id: id,
      };

      const result = await Order.getDistricts(null, value);
      setDistricts(result.data);
    }
  };
  const getWards = async (id) => {
    if (id) {
      const value = {
        district_id: id,
      };
      const result = await Order.getWards(null, value);

      setWards(result.data);
    }
  };

  const handleChangeProvinces = async (value) => {
    await setDataUser({ ...dataUser, district_id: "", ward_id: "" });
    await form.resetFields(["AMV_district_id", "AMV_ward_id"]);
    await setDistricts([]);
    await setWards([]);

    if (value) {
      getDistricts(value);
    }
  };

  const handleChangeDistricts = async (value) => {
    await setDataUser({ ...dataUser, ward_id: "" });
    await form.resetFields(["AMV_ward_id"]);
    await setWards([]);

    if (value) {
      getWards(value);
    }
  };
  const disabledDateNow = (current) => {
    return moment() < current;
  };
  const onSubmit = async (value) => {
    setLoading(true);
    // console.log(value);

    if (idUser) {
      //edit
      const data = {
        update_name: value ? value.AMV_register_name : "",
        update_gender: value ? value.AMV_register_gender : "",

        update_birth_day: value
          ? moment(value.AMV_register_birth_day).unix()
          : moment().unix(),
        update_email: value ? value.AMV_register_email : "",
        update_address: value ? value.AMV_register_address : "",
        update_cccd: value ? value.AMV_register_cccd : "",
        update_province: value ? value.AMV_province_id : "",
        update_district: value ? value.AMV_district_id : "",
        update_code_inject: value ? value.AMV_code_note : "",
        update_ward: value ? value.AMV_ward_id : "",
      };

      //
      console.log(data, "data");
      const res = await Order.UpdateProfile(data);
      // console.log(res, "res");

      // console.log("res2", res2);
      if (res && res.meta && res.meta.statusCode === 200) {
        const res2 = await dispatch(UserInfo());
        if (res2 && res2.meta && res2.meta.statusCode === 200) {
          setLoading(false);
          return message.success("Cập nhật thành công" || "");
        }
        setLoading(false);
        return message.success("Cập nhật thành công" || "");
      } else {
        setLoading(false);
        return message.error(res.meta.msg || "");
      }
    } else {
      //register

      const data = {
        register_name: value ? value.AMV_register_name : "",
        register_gender: value ? value.AMV_register_gender : "",

        register_birth_day: value
          ? moment(value.AMV_register_birth_day).unix()
          : moment().unix(),
        register_phone_number: value ? value.AMV_register_phone_number : "",
        register_email: value ? value.AMV_register_email : "",
        register_address: value ? value.AMV_register_address : "",
        register_password: value ? value.AMV_register_password : "",
        register_cccd: value ? value.AMV_register_cccd : "",
        register_province: value ? value.AMV_province_id : "",
        register_district: value ? value.AMV_district_id : "",
        register_code_inject: value ? value.AMV_code_note : "",
        register_ward: value ? value.AMV_ward_id : "",
      };

      //

      const res = await Order.UserRegister(data);

      console.log(res);
      if (res && res.meta && res.meta.statusCode === 200) {
        setLoading(false);
        return message.success("Chúc mừng bạn đã đăng kí thành công" || "");
      } else {
        setLoading(false);
        return message.error(res.meta.msg || "");
      }
    }

    setLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Bạn chưa nhập đầy đủ thông tin");
    return;
  };

  const initialValue = {
    AMV_register_name: dataUser.name || "",

    AMV_register_gender: dataUser.gender || "",

    AMV_register_birth_day: dataUser.birth_day
      ? moment.unix(dataUser.birth_day)
      : "",

    AMV_register_cccd: dataUser.cccd || "",
    AMV_province_id: dataUser.province_id || [],
    AMV_district_id: dataUser.district_id || [],
    AMV_code_note: dataUser.code_inject || "",
    AMV_ward_id: dataUser.ward_id || [],

    AMV_register_phone_number: dataUser.phone_number || "",

    AMV_register_email: dataUser.email || "",
    AMV_register_address: dataUser.address || "",
    AMV_register_password: idUser
      ? JSON.parse(localStorage.getItem("INFO_LOGIN")).password
      : "",
    AMV_register_password_confirm: idUser
      ? JSON.parse(localStorage.getItem("INFO_LOGIN")).password
      : "",
  };

  return (
    <div>
      {loading && <LoadingConfig title="" />}

      <Form
        className="RegisterUserForm"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
        initialValues={initialValue}
      >
        <div className="content__content--one row">
          {/* <!-- name --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_register_name"
              hasFeedback
              rules={RULES_ANTD.name}
              label="Họ và tên người đăng ký"
            >
              <Input placeholder="Họ và tên người tiêm (*)" />
            </Form.Item>
          </div>
          {/* <!-- Gender --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_register_gender"
              hasFeedback
              rules={RULES_ANTD.gender}
              label="Giới tính "
            >
              <Select placeholder="Giới Tính (*)" allowClear>
                <Select.Option value="MALE">Nam</Select.Option>
                <Select.Option value="FEMALE">Nữ</Select.Option>
              </Select>
            </Form.Item>
          </div>
          {/* <!-- date --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_register_birth_day"
              hasFeedback
              rules={RULES_ANTD.birth_day}
              label="Ngày sinh"
            >
              <DatePicker
                // onChange={handleChangeUserRegister}

                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder="Ngày sinh định dạng 25/03/2021 (*)"
                disabledDate={disabledDateNow}
              />
            </Form.Item>
          </div>
          {/* <!-- mã số tiêm chủng  --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_code_note"
              hasFeedback
              label="Mã sổ tiêm chủng"
            >
              <Input placeholder="Mã số tiêm chủng nếu có" />
            </Form.Item>
          </div>
          <div className="col-md-12 col-sm-12">
            <Form.Item
              name="AMV_register_cccd"
              hasFeedback
              label="Căn cước công dân"
              // rules={[RULES_ANTD.common]}
            >
              <Input placeholder="Căn cước công dân (*)" />
            </Form.Item>
          </div>

          {/* <!-- phone --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Điện thoại đăng ký "
              name="AMV_register_phone_number"
              hasFeedback
              rules={idUser ? null : RULES_ANTD.phone}
            >
              <Input
                placeholder="Điện thoại đăng ký (*)"
                disabled={idUser ? true : false}
              />
            </Form.Item>
          </div>
          {/* <!-- email --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Email đăng ký"
              name="AMV_register_email"
              hasFeedback
              rules={RULES_ANTD.email}
            >
              <Input placeholder="Email đăng kí (*)" />
            </Form.Item>
          </div>
          {/* Mật khâu */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Mật khẩu"
              name="AMV_register_password"
              hasFeedback
              rules={idUser ? null : RULES_ANTD.password}
            >
              <Input.Password
                placeholder="Mật khẩu ít nhất 8 kí tự (*)"
                // onChange={handleTypingLogin}
                disabled={idUser ? true : false}
              />
            </Form.Item>
          </div>
          {/* Nhập lại mật khẩu  */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Nhập lại mật khẩu"
              name="AMV_register_password_confirm"
              hasFeedback
              rules={idUser ? null : RULES_ANTD.confirm_password}
            >
              <Input.Password
                placeholder="Nhập lại mật khẩu"
                disabled={idUser ? true : false}
              />
            </Form.Item>
          </div>

          <div className="col-md-12 col-sm-12">
            <Form.Item
              name="AMV_register_address"
              hasFeedback
              label="Địa chỉ "
              rules={[RULES_ANTD.common]}
            >
              <Input placeholder="Địa chỉ (*)" />
            </Form.Item>
          </div>

          {/* <!-- Quốc gia  --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Quốc gia"
              name="AMV_country_id"
              hasFeedback
              rules={[RULES_ANTD.common]}
              initialValue={"Việt Nam"}
            >
              <Select placeholder="Quốc gia" showSearch allowClear>
                <Select.Option
                  key={0}
                  value="Việt Nam"
                  className="Việt Nam"
                  checked
                >
                  Việt Nam
                </Select.Option>
              </Select>
            </Form.Item>
          </div>
          {/* <!-- tỉnh thành  --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Tỉnh thành"
              name="AMV_province_id"
              hasFeedback
              rules={RULES_ANTD.provinces}
            >
              <Select
                placeholder="Tỉnh thành"
                onChange={handleChangeProvinces}
                showSearch
                allowClear
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                notFoundContent={
                  provinces?.length < 1 ? <Spin size="small" /> : null
                }
              >
                {provinces && provinces?.length > 0
                  ? sortPrioritize(provinces, [
                      { name: "Hà Nội" },
                      { name: "Hồ Chí Minh" },
                    ]).map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item._id}
                        className={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))
                  : null}
              </Select>
            </Form.Item>
          </div>
          {/* <!-- quân huyện --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Quận huyện"
              name="AMV_district_id"
              hasFeedback
              rules={RULES_ANTD.districts}
            >
              <Select
                placeholder="Quận huyện"
                allowClear
                onChange={handleChangeDistricts}
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                notFoundContent={
                  districts?.length < 1 ? <Spin size="small" /> : null
                }
              >
                {districts && districts?.length > 0
                  ? sortPrioritize(districts).map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item._id}
                        className={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))
                  : null}
              </Select>
            </Form.Item>
          </div>
          {/* <!-- phường xã --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_ward_id"
              label="Phường xã"
              hasFeedback
              rules={RULES_ANTD.wards}
            >
              <Select
                placeholder="Phường xã"
                label="Phường xã"
                allowClear
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                notFoundContent={
                  wards?.length < 1 ? <Spin size="small" /> : null
                }
              >
                {wards && wards?.length > 0
                  ? sortPrioritize(wards).map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item._id}
                        className={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))
                  : null}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12">
            <div className="captcha pt-3 pb-3">
              <ReCAPTCHA
                sitekey={KEY_RECAPTCHA}
                onChange={handleChangeCaptcha}
              />
            </div>
          </div>
          <div className="col-12">
            <button
              className="btn btnSubmit   mb-4"
              disabled={captcha ? false : true}
            >
              {idUser ? "Cập nhật người dùng " : "   Đăng kí người dùng"}
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default RegisterUserForm;
